module.exports = __webpack_public_path__ + "static/media/externallinkicon.77c45ad8.png";